import { epochToTimeDistribution } from './time-distribution.util';
import { logger } from './logger';
export function blobFolderUriBuilder({ tenantId, applicationId }) {
    return `${tenantId}/${applicationId}/`;
}
export function blobUriBuilder({ filename, tenantId, applicationId }) {
    return `${blobFolderUriBuilder({ tenantId, applicationId })}${filename}`;
}
export async function blobToPlatformNotifications(blob) {
    const fileReader = new FileReader();
    return new Promise((resolve, reject) => {
        fileReader.onloadend = (ev) => {
            var _a;
            try {
                logger.debug('file loaded event', ev);
                const notifications = JSON.parse((_a = ev.target) === null || _a === void 0 ? void 0 : _a.result);
                resolve(notifications);
            }
            catch (e) {
                logger.error('unable to parse blob content', e, ev);
                reject(e);
            }
        };
        fileReader.onerror = reject;
        fileReader.readAsText(blob);
    });
}
export function blobNameToEpoch(blobName) {
    const fileNameMask = new RegExp(/(\d+)-(\d+)\.json$/g);
    try {
        const [foundEpoch] = [...blobName.matchAll(fileNameMask)];
        return { start: new Date(Number(foundEpoch[1])), end: new Date(Number(foundEpoch[2])) };
    }
    catch (e) {
        return false;
    }
}
export function blobNameToTimeDistribution(blobName) {
    const epoch = blobNameToEpoch(blobName);
    return epochToTimeDistribution(epoch);
}
//# sourceMappingURL=azure-storage-blob.util.js.map